import { render, staticRenderFns } from "./OrderTableElementTable.vue?vue&type=template&id=53a6f517&"
import script from "./OrderTableElementTable.vue?vue&type=script&lang=js&"
export * from "./OrderTableElementTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableElementTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports